import React, { useState } from "react";
import { MenuContext } from "./menu_context";

const MenuContextProvider = ({ children }) => {
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);
  const [menuFunctions, setMenuFunctions] = useState();

  const changeMenuVisibility = () => {
    setIsMenuCollapsed((prev) => !prev);
  };

  const setMenuFunctionsHandler = (data) => {
    setMenuFunctions(data);
  }

  const contextValue = {
    isMenuCollapsed,
    changeMenuVisibility,
    menuFunctions,
    setMenuFunctionsHandler,
  };

  return (
    <MenuContext.Provider value={contextValue}>{children}</MenuContext.Provider>
  );
};

export default MenuContextProvider;
